@if (icon()) {
  <soft-icon [name]="icon()" class="mr-2 !color-inputBorder"></soft-icon>
}
<input
  [type]="type"
  [value]="
    escapeHtml
      ? (_value() ?? null | deserializeHtmlCharacterEntities)
      : (_value() ?? null)
  "
  (keydown)="$event.key !== 'Enter' && $event.stopPropagation()"
  (input)="setValue(inputElement.value)"
  [readOnly]="readonly"
  [autocomplete]="autocomplete"
  placeholder="{{
    placeholder ||
      (type === 'email'
        ? '#UI_CORE.COMPONENTS.INPUT.EMAIL_PLACEHOLDER'
        : '#UI_CORE.COMPONENTS.INPUT.PLACEHOLDER') | translate
  }}"
  (blur)="onTouch(); blur.emit()"
  (focus)="focus.emit()"
  #inputElement
/>
<ng-content></ng-content>
